<template>
  <div class="tags" v-if="items.length > 0">
    <ul>
      <li class="tag" v-for="tag in items" :key="tag">{{ tag }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Tags",
  props: ["items"]
};
</script>

<style scoped lang="scss">
.tags {
  margin-top: 10px;
  width: 100%;

  ul {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .tag {
    margin: 3px 10px 3px 0;
    background-color: var(--ghostWhite);
    border-radius: 5px;
    padding: .3em .5em;
    font-size: 1rem;
    font-weight: var(--fontWeightBold);
    line-height: .9;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
